import React, { Dispatch, memo, ReactElement, ReactText, useMemo } from 'react'
import { ControlButton } from 'live/components/ui/CardContainer'
import i18n from 'live/services/i18n'
import SearchBar, { NoResults } from 'live/components/ui/SearchBar'
import * as S from './styled'
import GenericTable, { TableColumns, TableData } from '../GenericTable/GenericTable'

interface ControlProps {
    fullscreen?: boolean
    multiSelect?: boolean
    onClickToAdd?: () => void
    toggleFullscreen?: () => void
    toggleMultiSelect?: () => void
    // clearSelectedItems: () => void
}

export const CardControls: React.FC<ControlProps> = ({
    fullscreen,
    multiSelect,
    onClickToAdd,
    toggleFullscreen,
    toggleMultiSelect
}) => {
    return (
        <>
            <S.RightSideControlsContainer>
                {!multiSelect && onClickToAdd && (
                    <ControlButton onClick={onClickToAdd}>
                        <span>{i18n('ADD ITEM')}</span>
                        <i className="far fa-plus-circle" />
                    </ControlButton>
                )}

                {toggleMultiSelect && (
                    <ControlButton onClick={toggleMultiSelect}>
                        {multiSelect ? (
                            <S.FinishSelectionButton>
                                <span>{i18n('CANCEL SELECTION')}</span>
                                <i className="far fa-times-square" />
                            </S.FinishSelectionButton>
                        ) : (
                            <React.Fragment>
                                <span>{i18n('SELECT MULTIPLE')}</span>
                                <i className="far fa-check-square" />
                            </React.Fragment>
                        )}
                    </ControlButton>
                )}
                {toggleFullscreen ? (
                    fullscreen ? (
                        <ControlButton onClick={toggleFullscreen}>
                            <span>{i18n('RESTORE')}</span>
                            <i className="far fa-compress-wide" />
                        </ControlButton>
                    ) : (
                        <ControlButton onClick={toggleFullscreen}>
                            <span>{i18n('EXPAND')}</span>
                            <i className="far fa-expand-wide" />
                        </ControlButton>
                    )
                ) : null}
            </S.RightSideControlsContainer>
        </>
    )
}

interface Props {
    title?: string
    data?: TableData[]
    fullscreen?: boolean
    selectedIds?: Set<ReactText>
    columns: TableColumns
    dataIndexToFilter: string
    stickyControls?: boolean
    filterTerm: string
    setFilterTerm: Dispatch<string>
    renderControls?: () => ReactElement
    multiSelect?: boolean
    onClickRow?: (row: any, index: number) => void
    onSelectRow?: (ids: Set<React.ReactText>) => void
}
const CardTable: React.FC<Props> = ({
    title,
    data = [],
    fullscreen,
    columns,
    selectedIds,
    dataIndexToFilter,
    stickyControls,
    renderControls,
    setFilterTerm,
    filterTerm,
    onClickRow,
    onSelectRow,
    multiSelect
}) => {
    const filterProps = useMemo(() => ({ term: filterTerm, column: dataIndexToFilter }), [dataIndexToFilter])

    return (
        <S.CardContainer
            title={title}
            stickyControls={stickyControls}
            fullscreen={!!fullscreen}
            renderControls={renderControls}
        >
            <SearchBar className="search-bar" filter={filterTerm} setFilter={setFilterTerm} />
            <S.TableContainer>
                <GenericTable
                    filterProps={filterProps}
                    data={data}
                    columns={columns}
                    onClickRow={onClickRow}
                    multiSelect={multiSelect}
                    selectedIds={selectedIds}
                    onSelectRow={onSelectRow}
                />
            </S.TableContainer>
        </S.CardContainer>
    )
}

export default memo(CardTable)
